import { render } from "./QuizType4.vue?vue&type=template&id=4aaaaa03&scoped=true"
import script from "./QuizType4.vue?vue&type=script&lang=js"
export * from "./QuizType4.vue?vue&type=script&lang=js"

import "./QuizType4.vue?vue&type=style&index=0&id=4aaaaa03&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aaaaa03"]])

export default __exports__